export default {
  mute: 'Mute',
  unmute: 'Unmute',
  hangup: 'Hang up',
  reject: 'Reject',
  hold: 'Hold',
  onHold: 'On Hold',
  transfer: 'Transfer',
  more: 'More',
  stopRecord: 'Stop Recording',
  record: 'Record',
  showKeypad: 'Keypad',
  hideKeypad: 'Hide Keypad',
  unHold: 'Unhold',
  forward: 'Forward',
  ignore: 'Ignore',
  voicemail: 'To Voicemail',
  custom: 'Custom',
  answerAndEnd: 'Answer & End',
  answerAndHold: 'Answer & Hold',
  answer: 'Answer',
  completeTransfer: 'Complete transfer',
  reply: 'Reply',
  add: 'Add',
  mergeCall: 'Merge with active call',
  endCallForEveryone: 'End call for everyone',
  leaveCall: 'Leave call',
  leaveOrEndCall: 'Leave or end call?',
} as const;
